"use client"

import { useState, useEffect } from "react"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { ArrowRight } from "lucide-react"

const BlogNavbar = () => {
    const [scrolled, setScrolled] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const pathname = usePathname()

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 20)
        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden"
        } else {
            document.body.style.overflow = "unset"
        }
    }, [isOpen])

    const navItems = [
        { href: "/", label: "Home" },
        { href: "/#book", label: "Agentic AI" },
        { href: "/blog", label: "Blog" },
        { href: "https://rakeshgohel.substack.com", label: "NewsLetter" },
        { href: "https://maven.com/rakeshgohel/ai-agent-engineering-react-rag-multi-agent", label: "New Course" },
    ]

    return (
        <>
            <nav
                className={`fixed top-0 w-full z-50 transition-all duration-300 border-b ${scrolled
                    ? "border-slate-200/40 shadow-sm"
                    : "border-transparent"
                    }`}
                style={{ backgroundColor: "#000000ff" }}
            >
                {/* "#d9e9fb"  */}
                <div className="max-w-[1800px] mx-auto px-8 lg:px-12">
                    <div className="flex justify-between items-center h-20">
                        {/* Logo */}
                        <div className="flex-shrink-0">
                            <Link
                                href="/"
                                className="flex items-center h-full text-[32px] leading-none tracking-tight transition-colors font-[family-name:var(--font-league-spartan)]"
                                style={{ color: "#ffffffff" }}
                            >
                                {/* "#1a2b55" */}
                                Rakesh Gohel
                            </Link>
                        </div>

                        {/* Desktop Menu */}
                        <div className="hidden min-[905px]:flex items-center gap-10">
                            {navItems.map((item) => (
                                <Link
                                    key={item.href}
                                    href={item.href}
                                    className={`px-0 py-[2px] rounded-full text-[16px] tracking-wider font-[family-name:var(--font-plus-jakarta-sans)] transition-all duration-200 ${pathname === item.href
                                        ? "underline underline-offset-4"
                                        : "hover:underline hover:underline-offset-2"
                                        }`}
                                    style={{ color: "#ffffffff" }}

                                >
                                    {item.label}
                                </Link>
                            ))}

                            <Link
                                href="/#contact"
                                className="flex items-center gap-0.5 px-3 py-1 rounded-full text-[15px] font-bold font-[family-name:var(--font-plus-jakarta-sans)] transition-all duration-200"
                                style={{ backgroundColor: "#1a2b55", color: "#ffffff" }}
                            >
                                Contact
                                <ArrowRight className="w-4 h-4 scale-x-[1.2]" strokeWidth={2} />
                            </Link>
                        </div>

                        {/* Mobile Toggle */}
                        <div className="min-[905px]:hidden">
                            <button
                                onClick={() => setIsOpen(!isOpen)}
                                className="p-2 focus:outline-none"
                                style={{ color: "#ffffff" }}
                                aria-label="Toggle menu"
                            >
                                <div className="w-6 h-5 relative flex flex-col justify-between">
                                    <span
                                        className={`w-full h-0.5 bg-current rounded-full transition-all duration-300 ${isOpen ? "rotate-45 translate-y-2" : ""
                                            }`}
                                    />
                                    <span
                                        className={`w-full h-0.5 bg-current rounded-full transition-all duration-300 ${isOpen ? "opacity-0" : ""
                                            }`}
                                    />
                                    <span
                                        className={`w-full h-0.5 bg-current rounded-full transition-all duration-300 ${isOpen ? "-rotate-45 -translate-y-2.5" : ""
                                            }`}
                                    />
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Mobile Menu Overlay */}
            <div
                className={`fixed inset-0 z-40 bg-white pt-20 px-6 transition-all duration-300 min-[901px]:hidden ${isOpen
                    ? "opacity-100 pointer-events-auto translate-y-0"
                    : "opacity-0 pointer-events-none -translate-y-full"
                    }`}
            >
                <div className="flex flex-col space-y-4">
                    {navItems.map((item, idx) => (
                        <Link
                            key={item.href}
                            href={item.href}
                            onClick={() => setIsOpen(false)}
                            className="text-2xl font-medium hover:pl-2 transition-all duration-300 border-b border-slate-100 pb-4"
                            style={{ color: "#1a2b55", transitionDelay: `${idx * 50}ms` }}
                        >
                            {item.label}
                        </Link>
                    ))}
                    <Link
                        href="/#contact"
                        onClick={() => setIsOpen(false)}
                        className="mt-4 w-full py-4 flex items-center justify-center gap-2 rounded-xl font-bold text-xl transition-colors"
                        style={{ backgroundColor: "#1a2b55", color: "#ffffff" }}
                    >
                        Contact Me
                        <ArrowRight className="w-5 h-5" />
                    </Link>
                </div>
            </div>
        </>
    )
}

export default BlogNavbar
